import { isWorkflowScheduled } from '@/services/workflows/workflowMappers'

/** Recurring workflows attached to a chat. */
export function selectScheduledThreadIds(workflows = []) {
  const ids = new Set()
  for (const workflow of workflows) {
    if (!workflow?.conversationId || !isWorkflowScheduled(workflow)) continue
    ids.add(String(workflow.conversationId))
  }
  return ids
}

/** Workflows that send through an established connected app. */
export function selectSendGrantThreadIds(workflows = []) {
  const ids = new Set()
  for (const workflow of workflows) {
    if (!workflow?.conversationId || !workflow.sendGrant) continue
    ids.add(String(workflow.conversationId))
  }
  return ids
}
